module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-9-b51a98b0c35b5cc09316b1c94ce2837b.jpg";